export default {
    data () {
        return {
            isOpen: false
        }
    },

    created () {
        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.close()
            }
        })
    },

    methods: {
        toggle (event) {
            if (this.beforeToggle !== undefined) {
                this.beforeToggle(event)
            }

            this.isOpen ? this.close() : this.open()
        },

        open () {
            this.isOpen = true
            this.$emit('toggle', this.isOpen)
        },

        close () {
            this.isOpen = false
            this.$emit('toggle', this.isOpen)
        }
    }
}
